export enum HaloContextDispatchActionType {
	setStartTime,
	setEndTime,
	setCustomStartTime,
	setCustomEndTime,
}
